<template>
    <div id="row" class="d-flex flex-column align-items-left">
      <div class="row1 d-flex flex-rows justify-content-between align-items-center">
        <div class="lg1">
          <span class="title">{{title.lg1}}</span> <span class="subtitle">{{subtitle.lg1}}</span>
        </div>
        <div class="price float-right">{{price}}</div>
      </div>
      <div class="row2 lg2">
        <span class="title">{{title.lg2}}</span > <span class="subtitle">{{subtitle.lg2}}</span>
        <div class="price float-right">{{ freeOfCharge }}</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'MercureRatesHorizontalV1RatesRow',
  props: {
    servicesLg1: Object,
    servicesLg2: Object
  },
  computed: {
    title () {
      return {lg1: this.servicesLg1.label_value, lg2: this.servicesLg2.label_value}
    },
    subtitle () {
      return {lg1: this.servicesLg1.sub_label, lg2: this.servicesLg2.sub_label}
    },
    price () {
      return this.servicesLg1.msr_value
    },
    price2 () {
      return this.servicesLg2.msr_value
    },
    freeOfCharge () {
      if (this.price === this.price2) {
        return ''
      } else {
        return this.price2
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_mercure.scss";

#row {
  width: 100%;
  @include heightPercent(120);
  border-top: 1px solid $purple;

  .row1 {
    margin-top: 0.3vh;
    .lg1 {
      max-height: 2rem;
      overflow: hidden;

      .title {
        font-family: "HouschkaAltPro-DemiBold";
        text-transform: uppercase;
        @include fontSize(35);
      }

      .subtitle {
        font-family: "HouschkaAltPro-Medium";
        @include fontSize(35);
      }
    }

    .price {
      font-family: "HouschkaAltPro-DemiBold";
      @include fontSize(42);
      color: $purple;
      white-space: nowrap;
    }
  }

  .row2 {
    //margin-top: 0.8vh;
    max-height: 2em;
    overflow: hidden;

    .title {
      font-family: "HouschkaAltPro-DemiBold";
      text-transform: uppercase;
      @include fontSize(29);
    }

    .subtitle {
      font-family: "HouschkaAltPro-Medium";
      @include fontSize(29);
    }

    .price {
      font-family: "HouschkaAltPro-DemiBold";
      @include fontSize(34);
      color: $gold;
      white-space: nowrap;
      margin-top: -0.2em;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mercure/rates/horizontal/v1/services/rowServices.vue